import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'db-manage-dns-list',
    templateUrl: './manage-dns-list.component.html',
    styleUrls: ['./manage-dns-list.component.scss'],
    standalone: false
})
export class ManageDnsListComponent implements OnInit {
  @Input() zone;
  @Output() addRecord: EventEmitter<any> = new EventEmitter<any>();
  @Output() addAlternativeRecord: EventEmitter<any> = new EventEmitter<any>();
  @Output() confirmRemove: EventEmitter<any> = new EventEmitter<any>();
  isCopied: boolean[] = [];
  RemoveRecord = [
    {
      icon: 'plugins',
      label: 'text_confirmRecordRemove.header',
      action: (item) => {
        this.confirmRemove.emit(item);
      }
    }
  ];

  constructor() {
  }

  ngOnInit() {
  }

  public copiedNameServer(index: number) {
    this.isCopied[index] = true;
    setTimeout(() => this.isCopied[index] = false, 800);
  }

  public replaceString(str: string) {
      return str.replace(/"/g, "").replace(/\\/g, "").replace(/\\n/g, "<br/>");
  }
}
